import { FC } from "react";
import BaseTooltipWrapper from "@/components/BaseWrappers/BaseTooltipWrapper";
import { createChallengeTooltipsText } from "@/features/challenge/utils/CreateChallengeTooltips";
import CreateChallengeMixedTextSelectInput from "./CreateChallengeMixedTextSelectInput";
import FormErrorMessage from "@/components/FormErrorMessage/FormErrorMessage";
import { Box, Flex, Heading, RadioCards, Text } from "@radix-ui/themes";
import { InfoCircledIcon } from "@radix-ui/react-icons";

export const ChallengeCriteriaPicker: FC<{
  critType: string;
  setCritType: React.Dispatch<React.SetStateAction<string>>;
  state: any;
  fields: any;

  setFieldValue: any;
  handleUpdateCriteriaList: (
    type: "empty" | "add" | "remove" | "addEmpty",
    value?: number,
    key?: any
  ) => void;
  errors: any;
  name: string;
  isEdit: boolean;
}> = ({
  critType,
  setCritType,
  state,
  fields,
  setFieldValue,
  handleUpdateCriteriaList,
  errors,
  name,
  isEdit,
}) => {
  const getFilteredFields = () => {
    if (Object.entries(state).length === 0) {
      return fields;
    }

    const filteredVal = fields.map((field) => {
      if (!Object.entries(state).find(([key, value]) => key === field.value)) {
        return field;
      }
      return;
    });
    return filteredVal;
  };

  return (
    <Flex gap="3" direction="column">
      <Flex gap="2" direction="column">
        <BaseTooltipWrapper
          overlayTrigger={
            <Flex align="center" gap="1">
              <Heading as="h3" size="4">
                Criteria{" "}
                {isEdit && (
                  <Text size="1" color="gray">
                    ( cannot be edited )
                  </Text>
                )}
              </Heading>
              <InfoCircledIcon />
            </Flex>
          }
          tooltipContent={
            createChallengeTooltipsText?.[
              critType === "simple" || critType === "advanced"
                ? `tooltipCriteria${critType}`
                : "criteria"
            ]
          }
        />
        <Flex gap="3" align="center">
          <RadioCards.Root columns={{ initial: "1", sm: "3" }}>
            <RadioCards.Item
              value="simple"
              onClick={(e: any) => setCritType(e.target.value)}
            >
              <Flex direction="column">
                <Text weight="bold">Simple</Text>
                <Text size="1" color="gray">
                  Consists of a single criteria.
                </Text>
              </Flex>
            </RadioCards.Item>

            <RadioCards.Item
              value="advanced"
              onClick={(e: any) => setCritType(e.target.value)}
            >
              <Flex direction="column">
                <Text weight="bold">Advanced</Text>
                <Text size="1" color="gray">
                  Consists of several criteria.
                </Text>
              </Flex>
            </RadioCards.Item>
          </RadioCards.Root>
        </Flex>
      </Flex>

      <Flex gap="3" direction="column">
        {!isEdit && critType && (
          <CreateChallengeMixedTextSelectInput
            critType={critType}
            fields={critType === "advanced" ? getFilteredFields() : fields}
            initialField={""}
            initialNumber={1}
            key={`${""}_${1}`}
            objectsLength={Object.entries(state).length}
            index={0}
            handleUpdateCriteriaList={handleUpdateCriteriaList}
            isSelectedOption={false}
            isEdit={isEdit}
            selectedFields={Object.keys(state)}
          />
        )}

        {critType === "advanced" &&
          Object.entries(state)
            .reverse()
            .map(([key, value], index) => {
              return (
                <>
                  <CreateChallengeMixedTextSelectInput
                    critType={isEdit ? "advanced" : critType}
                    fields={fields}
                    initialField={key}
                    initialNumber={value as string}
                    key={`${key}_${value}`}
                    objectsLength={Object.entries(state).length}
                    index={index}
                    handleUpdateCriteriaList={handleUpdateCriteriaList}
                    isSelectedOption
                    isEdit={isEdit}
                    selectedFields={Object.entries(state)}
                  />
                </>
              );
            })}
      </Flex>
      {errors && errors[name] && (
        <FormErrorMessage text={errors[name]} isVisible={errors[name]} />
      )}
    </Flex>
  );
};
